import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FileUploadStatus } from '../models/file-upload-status';
import { finalize } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/shared/util/local-storage';
import { FileUploaderService } from '../services/file-uploader/file-uploader.service';
import { HttpClient } from '@angular/common/http';

/**
 * Componente de envio de arquivo csv de ocorrências ao servidor.
 */
@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css'],
  providers: [
    { 
      provide: FileUploaderService, 
      useFactory: (http: HttpClient) => {
        return new FileUploaderService('evento/upload', http);
      }, 
      deps: [HttpClient],
    }
  ]
})
export class FileUploaderComponent implements OnInit {

  /** Indica o nome do arquivo, ou uma mensagem para selecionar um arquivo csv. */
  selectedFile: File = null;

  /** Enum com as opções possíveis do status do envio do arquivo das ocorrências. */
  FileUploadStatus = FileUploadStatus;

  /** Indica o status atual do envio de um arquivo de ocorrências. */
  currentFileUploadStatus: FileUploadStatus = FileUploadStatus.IDLE;

  /** Mensagem de resposta do envio do csv das ocorrências. */
  fileUploadResultMessage: string = '';

  /** Referência ao campo de upload de arquivos */
  @ViewChild('uploadField') uploadField: ElementRef;

  /** Evento que indica que o servidor iniciou o upload do arquivo de ocorrências. */
  @Output() uploadStarted = new EventEmitter();

  constructor(
    private fileUploaderService: FileUploaderService, 
    private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
  }

  /**
   * Dispara um click no botão de upload
   */
   triggerUploadField() {
    this.uploadField.nativeElement.click();
  }

  /**
   * Trata a seleção de arquivos para upload
   * @param event evento de mudança do campo, com o arquivo selecionado.
   */
  onFilesChanged(event: Event) {

    this.selectedFile = (event.target as HTMLInputElement).files[0];
  }

  /**
   * Remove o arquivo previamente selecionado
   */
  removeFile() {
    console.log('limpou')
    this.selectedFile = null;
  }

  /**
   * Trata o envio do arquivo das ocorrências ao servidor.
   */
  sendFile() {

    let file = this.selectedFile;
    let formData = new FormData();
    let filename = `${(new Date())}_${file.name}`;
    formData.append('eventFile', file, filename);
    formData.append('userId', this.localStorageService.getUserId());

    // envia arquivo
    this.fileUploaderService.upload(formData)
    .pipe(
      // executa ao final, independentemente de sucesso ou falha
      finalize(() => {
        this.selectedFile = null;
      })
    )
    .subscribe((result: any) => {
      this.fileUploadResultMessage = result.message;
      this.uploadStarted.emit();
    }, error => {
    });

  }

}
